import { useSearchParams } from '@remix-run/react';

interface Props {
  subscriptionTier: string;
  subscriptionStatus: string;
  isLoggedIn: boolean;
}

const useUserStatus = ({ subscriptionTier, subscriptionStatus, isLoggedIn }: Props) => {
  const [searchParams] = useSearchParams();

  // isLoggedInOrSubscribed
  const subscribed = searchParams.get('status') === 'subscribed';
  const isLoggedInOrSubscribed = isLoggedIn || subscribed;

  // isPremiumSubscription
  const upgraded = searchParams.get('upgraded') === 'true';
  const isPremium = subscriptionTier === 'premium' && subscriptionStatus !== 'paused';
  const isPremiumSubscription = isPremium || upgraded;

  return {
    isLoggedInOrSubscribed,
    isPremiumSubscription,
  };
};

export default useUserStatus;
